import React from 'react';
import AdminSupportTicketTable from 'components/admin/support/AdminSupportTicketTable';

const AdminSupportTicketsPage: React.FC = () => {
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
        <h1 className="h2">Destek Talepleri</h1>
      </div>
      <AdminSupportTicketTable />
    </>
  );
};

export default AdminSupportTicketsPage;
